export default "__VITE_ASSET__BasG3Vcb__"